module.exports = __webpack_public_path__ + "img/627.Selver_spone.f97b8cdc.svg";